import React, { useEffect, useState } from "react";
import { getMe } from "../../services/authService";
import { getDashboardStats } from "../../services/dashboardService";

const Dashboard = () => {
  const [user, setUser] = useState(null);

  // ✅ initialize stats safely
  const [stats, setStats] = useState({
    complaints: 0,
    videos: 0,
    photoCategories: 0,
    galleryPhotos: 0,
    caseHearings: 0,
    notices: 0,
    contacts: 0,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([getMe(), getDashboardStats()])
      .then(([userRes, statsRes]) => {
        setUser(userRes);
        setStats(statsRes); // API data replaces defaults
      })
      .catch((err) => {
        console.error("Dashboard error:", err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="container-fluid">

      {/* Welcome */}
      <div className="bg-light border rounded p-4 mb-4 d-flex flex-column align-items-center shadow-sm">
        <h2 className="fw-bold text-dark mb-2">Welcome to the Admin Panel</h2>

        {user ? (
          <p className="fs-5 text-secondary mb-0">
            🙏 Namaste <strong>{user.username}</strong>, glad to see you back!
          </p>
        ) : (
          <p className="text-muted">Loading user info...</p>
        )}
      </div>

      {/* Stats */}
      {loading ? (
        <p className="text-center text-muted">Loading dashboard data...</p>
      ) : (
        <div className="row g-4">
          <StatCard title="Registered Complaints" value={stats.complaints} color="danger" />
          <StatCard title="Videos" value={stats.videos} color="primary" />
          <StatCard title="Photo Categories" value={stats.photoCategories} color="info" />
          <StatCard title="Gallery Photos" value={stats.galleryPhotos} color="success" />
          <StatCard title="Case Hearings" value={stats.caseHearings} color="warning" />
          <StatCard title="Notices / Tenders" value={stats.notices} color="secondary" />
          <StatCard title="Contact Messages" value={stats.contacts} color="dark" />
        </div>
      )}
    </div>
  );
};

export default Dashboard;

/* Reusable Stat Card */
const StatCard = ({ title, value, color }) => (
  <div className="col-xl-3 col-md-4 col-sm-6">
    <div className="card shadow-sm border-0 h-100 text-center p-3">
      <h6 className="text-muted mb-2">{title}</h6>
      <h2 className={`fw-bold text-${color}`}>{value}</h2>
    </div>
  </div>
);
